/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_ResendInputs */

const en_us2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

const pt_br2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const es_419_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const pt_pt2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const fr_fr2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renvoyer le code`)
};

const de_de2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code erneut senden`)
};

const it_it2_auth_code_resend = /** @type {(inputs: Auth_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinvia codice`)
};

/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Auth_Code_ResendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_resend = /** @type {((inputs?: Auth_Code_ResendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_ResendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_resend(inputs)
	if (locale === "es-419") return es_419_auth_code_resend(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_resend(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_resend(inputs)
	if (locale === "de-DE") return de_de2_auth_code_resend(inputs)
	if (locale === "it-IT") return it_it2_auth_code_resend(inputs)
	return en_us2_auth_code_resend(inputs)
});
export { auth_code_resend as "auth.code_resend" }